import { ContactUsPage, SubOffices } from '@pages/ContactUs/ContactUs.types';
import React from 'react';
import './ContactUsSideView.scss';

interface ContactUsSideViewProps {
  subOfficeList: SubOffices;
  pageLabels: ContactUsPage;
  onShowFindContactsBtnClick: () => void;
  showOffices: boolean;
}

export const ContactSideView = ({
  subOfficeList,
  pageLabels,
  onShowFindContactsBtnClick,
  showOffices,
}: ContactUsSideViewProps) => {
  return (
    <div className='c-card-margin'>
      {showOffices && Object.entries(subOfficeList).map(([key, value]) => {
        const officeType = key ? key.split('|') : '';
        if (officeType[1] == 'Main office' && value && Array.isArray(value)) {
          return (
            <div key={key} className='c-contact-main-office-section'>
              <div className='c-contact-heading-font'>
                <p>{officeType ? officeType[0] : ''}</p>
                {value.length <= 1 && <p>{value[0].OfficeName}</p>}
              </div>
              {value.length > 0 && (
                <div className='c-contact-main-office'>
                  {value.map((e, index) => {
                    if (e) {
                      return (
                        <div className='c-contact-main-office-list' key={index}>
                          {value.length > 1 && (
                            <>
                              <p>{e.OfficeName}</p>
                            </>
                          )}
                          <div className='labels-font' key={index.toString()}>
                            <p>{e.Address1}</p>
                            <p>{e.Address2}</p>
                            <p>{e.Address3}</p>
                            {e.Postal && <p>{e.Postal}</p>}
                            {e.City && <p>{e.City}</p>}
                            {e.State && <p>{e.State}</p>}
                            {e.PhoneNumber && e.PhoneNumber.trim() !== '' && (
                              <p>
                                {e.PhoneLabel && <span>{e.PhoneLabel}: </span>}
                                <a href={'tel:' + e.PhoneNumber}>{e.PhoneNumber}</a>
                              </p>
                            )}
                            {e.Fax && e.Fax != '' && (
                              <p>
                                {e.FaxLabel}: {e.Fax}
                              </p>
                            )}
                            {e.EmailAddress && e.EmailAddress.trim() !== '' && (
                              <p>
                                {e.EmailLabel && <span>{e.EmailLabel}: </span>}
                                <a href={'mailto:' + e.EmailAddress}>{e.EmailAddress}</a>
                              </p>
                            )}
                          </div>
                          <br />
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              )}
            </div>
          );
        }
      })}
      <a className='c-contact-color-labels' onClick={onShowFindContactsBtnClick}>
        {pageLabels.FindYourContactsLinkText}
      </a>
      <br />
      <h4 className='partner-label'>{pageLabels.PartnersLabel}</h4>
      <p className='partner-description'>{pageLabels.PartnerDescription}</p>
      <br />
      <a href={pageLabels.PartnerLink} target='_blank' rel='noreferrer'>
        <span className='c-contact-color-labels'>{pageLabels.FindYourPartnerLinkText}</span>
      </a>
    </div>
  );
};
